import {ToolTipData, BasicTooltipData, DeploymentToolTipData, StampToolTipData, AtwIssueToolTipData, DaySpecificTooltipData, ToolTipSubject, ToolTipSubjectResource, ToolTipDataType, ToolTipSubjectCompany, DragOverTooltipData} from '@/types';

export default class TooltipDataUtil {
    public static isDaySpecificData(tooltipData: ToolTipData | null): tooltipData is ToolTipData & ToolTipSubject & DaySpecificTooltipData {
        return !!tooltipData && 'day' in tooltipData && !!tooltipData.day;
    }

    public static isDeploymentData(tooltipData: ToolTipData | null): tooltipData is BasicTooltipData & ToolTipSubject & DeploymentToolTipData {
        return !!tooltipData && tooltipData.type === 'deployment';
    }

    public static isAtwIssueData(tooltipData: ToolTipData | null): tooltipData is BasicTooltipData & ToolTipSubject & AtwIssueToolTipData {
        return !!tooltipData && tooltipData.type === 'atwIssues';
    }

    public static isStampData(tooltipData: ToolTipData | null): tooltipData is BasicTooltipData & ToolTipSubject & StampToolTipData {
        return !!tooltipData && tooltipData.type === 'personalStamp';
    }

    public static isDragOverData(tooltipData: ToolTipData | null): tooltipData is BasicTooltipData & ToolTipSubject & DragOverTooltipData {
        return !!tooltipData && tooltipData.type === 'dragOver';
    }

    public static isResourceTooltip(tooltipData: ToolTipData | null): tooltipData is BasicTooltipData & ToolTipSubjectResource & ToolTipDataType {
        return !!tooltipData && 'resource' in tooltipData;
    }

    public static isCompanyTooltip(tooltipData: ToolTipData | null): tooltipData is BasicTooltipData & ToolTipSubjectCompany & ToolTipDataType {
        return !!tooltipData && 'company' in tooltipData;
    }
}
